// imageData.js
// import side_slider_1 from '../../assets/images/side_slider_1.jpg';
// import side_slider_2 from '../../assets/images/basketball_banner_7.jpg';
// import football_side_slider_1 from '../../assets/images/football_side_slider_1.jpg';
// import football_side_slider_2 from '../../assets/images/football_side_slider_2.jpg';
// import creighton_2 from '../../assets/images/creighton_2.webp'
// import creighton_4 from '../../assets/images/creighton_4.jpg'
import gta_1 from '../../assets/images/georgia_tech_n_8.png'
import gta_2 from '../../assets/images/georgia_tech_n_5.png'


export const sliderImages = [
  {
    id: 1,
    url: gta_1
  },
  {
    id: 2,
    url: gta_2
  },
];
